import { Fragment, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from '../pages/Login';
import Signup from '../pages/Signup';
import Success from '../pages/Signup/success';
//import Dashboard from '../pages/Dashboard';
//import Myaccount from '../pages/User/Myaccount';
import PrivateRoute from '../routes/privateRoutes'

import Skeleton from '../pages/Template/Sekeleton'

import Layout from './Layout';
import Header from '../pages/Template/Header'
import Footer from '../pages/Template/Footer'

//import PatientsIndex from '../pages/Forms/Patients/index'
//import PatientsCreate from '../pages/Forms/Patients/create'
//import PatientsEdit from '../pages/Forms/Patients/edit'

//import ProductIndex from '../pages/Forms/product/index'
//import ProductCreate from '../pages/Forms/product/create'
//import ProductEdit from '../pages/Forms/product/edit'

const Dashboard = lazy(() => import('../pages/Dashboard'));
const Myaccount = lazy(() => import('../pages/User/Myaccount'));

const MedicationsIndex = lazy(() => import('../pages/Forms/Medications/index'));

const PatientsIndex = lazy(() => import('../pages/Forms/Patients/index'));
const PatientsCreate = lazy(() => import('../pages/Forms/Patients/create'));
const PatientsEdit = lazy(() => import('../pages/Forms/Patients/edit'));

const PrescriptionCreate = lazy(() => import('../pages/Forms/Prescription/create'));
const PrescriptionEdit = lazy(() => import('../pages/Forms/Prescription/edit'));
const PrescriptionShow = lazy(() => import('../pages/Forms/Prescription/show'));
const PrescriptionRedirPdf = lazy(() => import('../pages/Forms/Prescription/redir-pdf'));

const ConsultationsInit = lazy(() => import('../pages/Forms/Consultations/init'));
const ConsultationsEdit = lazy(() => import('../pages/Forms/Consultations/edit'));

const RoutesApp = () => {
    return (
        <Router>

            <Suspense fallback={<Skeleton />}>

                <Routes>
                    
                    {/* Sem layout: login e signup */}
                    <Route exact path="/login" element={<Login/>} />
                    <Route exact path="/signup" element={<Signup/>} />
                    <Route exact path="/signup/success" element={<Success/>} />
                    <Route exact path="*" element={<Login/>} />

                    {/* roat publicica para visualizar a precrição */}
                    <Route exact path="/p/:slug" element={<PrescriptionShow/>} />
                    <Route exact path="/redir-pdf-url/:slug" element={<PrescriptionRedirPdf/>} />

                    {/* Com layout: logado */}
                    <Route element={<PrivateRoute />}>
                        <Route 
                            path="/dashboard" 
                            element={
                                <Layout>
                                    <Dashboard />
                                </Layout>
                            } 
                        />

                        
                        <Route 
                            path="/medications" 
                            element={
                                <Layout>
                                    <MedicationsIndex />
                                </Layout>
                            } 
                        />

                        <Route 
                            path="/patients" 
                            element={
                                <Layout>
                                    <PatientsIndex />
                                </Layout>
                            } 
                        />

                        <Route 
                            path="/patients/create" 
                            element={
                                <Layout>
                                    <PatientsCreate />
                                </Layout>
                            } 
                        />

                        <Route 
                            path="/patients/edit/:id" 
                            element={
                                <Layout>
                                    <PatientsEdit />
                                </Layout>
                            } 
                        />

                        <Route 
                            path="/prescription/create" 
                            element={
                                <Layout>
                                    <PrescriptionCreate />
                                </Layout>
                            }
                        />

                        <Route 
                            path="/prescription/edit/:id" 
                            element={
                                <Layout>
                                    <PrescriptionEdit />
                                </Layout>
                            } 
                        />

                        
                        <Route 
                            path="/consultations/init" 
                            element={
                                <Layout>
                                    <ConsultationsInit />
                                </Layout>
                            }
                        />

                        <Route 
                            path="/consultations/edit/:id" 
                            element={
                                <Layout>
                                    <ConsultationsEdit />
                                </Layout>
                            } 
                        />
                        

                        
                         
                    </Route>

                  
                    <Route element={<PrivateRoute />} >
                        <Route 
                            path="/myaccount" 
                            element={
                                <Layout>
                                    <Myaccount />
                                </Layout>
                            } 
                        />
                    </Route>
                    
                </Routes>

            </Suspense>

        </Router>
    );
}

export default RoutesApp;